export const LOAD = 'ethstats/minersTop/LOAD';
export const LOAD_SUCCESS = 'ethstats/minersTop/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/minersTop/LOAD_FAIL';
